import React from 'react';
import { MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline';
import { messages } from '../constants/messages';

const galleryImages = [
  '/images/grandentrance.jpeg',
  '/images/DTCPApproved.jpeg',
  '/images/ModernStreetLights.jpeg',
  '/images/childrenPlayArea.jpeg',
  '/images/24_7Security.jpeg',
  '/images/LandScapedParks.jpeg',
  '/images/hero.jpeg',
  '/images/24_7Security.jpeg',
  '/images/gallery_2.jpeg'
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-12 sm:py-24 px-4 sm:px-10 bg-white">
      <div className="container mx-auto text-center mb-10 sm:mb-16">
        <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4 block">{messages.gallery.badge}</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4 sm:mb-6 text-gray-900">
          {messages.gallery.titlePart1} <span className="text-[#EF5D22]">{messages.gallery.titlePart2}</span>
        </h2>
        <p className="text-gray-500 max-w-2xl mx-auto text-base sm:text-lg">
          {messages.gallery.description}
        </p>
      </div>
      
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {galleryImages.map((img, idx) => (
          <div key={idx} className="group relative overflow-hidden rounded-2xl sm:rounded-3xl h-56 sm:h-80 shadow-lg border border-gray-100">
            <img 
              src={img} 
              alt={`${messages.gallery.titlePart2} ${idx + 1}`} 
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center">
              <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-[#EF5D22] text-white flex items-center justify-center transform scale-0 group-hover:scale-100 transition-transform duration-500">
                <MagnifyingGlassPlusIcon className="w-6 h-6 sm:w-8 sm:h-8" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
